import CustomApplicationState from "@tIntermatic/Store/CustomApplicationState";

export const getMatchingIntermaticProductList = (state: CustomApplicationState) => {
    return state.t_data?.matchingIntermaticProducts?.value?.products;
};

export const getMatchingIntermaticPagination = (state: CustomApplicationState) => {
    return state.t_data?.matchingIntermaticProducts?.value?.pagination;
};
